// src/pages/RedirectTo.jsx
import { useMsal } from "@azure/msal-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const RedirectTo = ({ page }) => {
  const { inProgress } = useMsal();
  const navigate = useNavigate();
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (inProgress === "none" && !hasNavigated.current) {
      hasNavigated.current = true;
      navigate(page, { replace: true });
    }
  }, [inProgress, page, navigate]);

  return null;
};

export default RedirectTo;